export const imgPasswordVisible = require("../assets/ic_password_visible.png");
export const imgPasswordInVisible = require("../assets/ic_password_invisible.png");
export const DropdownLogo = require("../assets/button_dropdown.svg");
export const backDrop = require("../assets/backDrop.png");
export const LanguageLogo = require("../assets/langauge_logo.svg");
export const boxheaderLogo = require("../assets/boxheader_logo.svg");


